<template>
  <div class="form-selectbox">
    <div class="label">
      <template v-if="model[label] === undefined || model[label] === null">선택해주세요.</template>
      <p v-if="!multiple">{{ model[label] }}</P>
      <vs-chip
        v-for="(chip, index) in chips"
        v-else
        :key="index"
        closable
        @click="remove(chip)">
        {{ chip[label] }}
      </vs-chip>
    </div>
    <select
      :id="id"
      v-model="model"
      class="js-select"
    >
      <option v-if="isDefaultOptionMessage" value="" selected>{{ defaultOptionMessage }}</option>
      <option v-else-if="defaultOption" value="" selected>선택해주세요.</option>
      <option v-for="(list, index) in option" :key="index" :value="list">{{ list[label] }}</option>
    </select>
  </div>
</template>

<script>
import { find } from 'lodash';

export default {
  name: 'SelectBox',
  props: {
    label: {
      type: String,
      default: 'label',
    },
    option: {
      type: Array,
      required: true,
    },
    id: {
      type: String,
      required: true,
    },
    defaultOption: {
      type: Boolean,
      default: true,
    },
    defaultOptionMessage: {
      type: String,
      default: '',
    },
    defaultValue: {
      type: Number,
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      model: this.defaultValue !== null ? find(this.option, (item) => (item.id === this.defaultValue)) : '',
      chips: [],
    };
  },
  computed: {
    isDefaultOptionMessage() {
      return this.defaultOptionMessage !== '' && this.option.length === 0;
    },
  },
  watch: {
    model(val) {
      if (this.multiple) {
        this.chips.push(val);
        this.$emit('change', this.chips);
      } else {
        this.$emit('change', this.model);
      }
    },
  },
  methods: {
    setModel(val) {
      this.model = val;
    },
    remove(val) {
    },
    clearModel() {
      this.model = '';
    },
  },
};
</script>
